import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import useFieldFormError from 'lib/form/useFieldFormError';
import { DateTime } from 'luxon';
import { FieldValues, RegisterOptions, useController } from 'react-hook-form';

import FormField, { FormFieldProps } from '../FormField';
import DateTimeHeader from './DateTimeHeader';
import useDateValue from './useDateValue';

type CustomDateTimePickerProps = Omit<DateTimePickerProps<DateTime>, 'onChange' | 'value' | 'defaultValue' | 'name'>;
export interface FormDateTimeFieldProps extends FormFieldProps, CustomDateTimePickerProps {
  rules?: Omit<RegisterOptions<FieldValues, string>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
  size?: 'small' | 'medium';
}

function FormDateTimeField(props: FormDateTimeFieldProps) {
  const {
    fieldDescription,
    labelId,
    name,
    required,
    rules,
    size = 'small',
    ...dateTimePickerProps
  } = props;

  const { field } = useController({ name, rules: { required, ...rules } });
  const fieldError = useFieldFormError(name);
  const dateValue = useDateValue(field.value);

  return (
    <FormField
      name={name}
      labelId={labelId}
      required={required}
      fieldDescription={fieldDescription}
    >
      <DateTimePicker
        ampm={false}
        onChange={field.onChange}
        value={dateValue}
        closeOnSelect={false}
        slots={{
          toolbar: DateTimeHeader,
        }}
        slotProps={{
          textField: {
            size,
            error: Boolean(fieldError),
            fullWidth: true,
          },
        }}
        {...dateTimePickerProps}
      />
    </FormField>
  );
}

export default FormDateTimeField;
